import { WallesIpc } from '@flowus/shared';
import { useCallback, useEffect, useRef, type FC } from 'react';
import { cx } from '../cx';

interface Props {
  pageId: string;
  isDarkModel: boolean;
  className?: string;
  addonUrlParams?: string;
}
const time = Date.now();
export const AiPage: FC<Props> = (props) => {
  const { isDarkModel, className, addonUrlParams = '' } = props;
  const ref = useRef<HTMLIFrameElement | null>(null);
  const refresh = useCallback(() => {
    const dom = ref.current;
    if (!dom?.contentWindow) return;
    dom.contentWindow.postMessage(
      {
        type: WallesIpc.DARK_MODE,
        value: isDarkModel,
      },
      '*'
    );
  }, [isDarkModel]);

  useEffect(() => {
    refresh();
  }, [isDarkModel, refresh]);

  useEffect(() => {
    const iframe = ref.current;
    const load = () => {
      if (!iframe?.contentWindow) return;
      iframe.contentWindow.postMessage(
        {
          type: WallesIpc.PAGE_ID,
          value: props.pageId,
        },
        '*'
      );
    };
    iframe?.addEventListener('load', load);
    return () => {
      iframe?.removeEventListener('load', load);
    };
  }, [props.pageId]);
  let prefixUrl = '';
  if (location.hostname.includes('flowus.cn')) {
    prefixUrl = 'https://flowus.cn';
  } else {
    prefixUrl = location.origin;
  }
  return (
    <iframe
      allowFullScreen
      sandbox={cx(
        'allow-scripts allow-popups allow-top-navigation-by-user-activation allow-forms allow-same-origin',
        className
      )}
      ref={ref}
      onLoad={refresh}
      className="w-full h-full"
      // 因为这个页面会被缓存起来，所以加上v=xx后会拉新数据
      //如果有二级域名再打开这个页面会带上二级域名从而导致问题，所以这里用绝对值
      src={`${prefixUrl}/chat?${addonUrlParams}&v=${time}`}
      // src={`http://localhost:8085/chat/chat?${addonUrlParams}&v=${time}`}
    />
  );
};
